import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const CarouselStyle = (theme: Theme) => createStyles({
  container: {
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  slide : {
    minHeight:'100%',
    minWidth:'100%',
  },
  top : {
    textAlign: 'right',
  },
  bottom : {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '24px 64px',
    alignItems: 'center',
  },
  slideContainer : {
    display: 'flex',
    overflow: 'auto',
    position: 'relative',
    width: '100%',
    flex: 1,
    scrollSnapType: 'x mandatory',
    scrollSnapStop: 'always',
  },
  dot: {
    borderRadius: '20px',
    minHeight:'8px',
    minWidth:'8px',
    maxHeight:'8px',
    maxWidth:'8px',
    backgroundColor: styleColors.greyMedium2,
    transition: 'all 0.3s',
  }
  
});



// WEBPACK FOOTER //
// ./src/components/carousel/carousel.style.ts